export default __webpack_public_path__ + "static/media/aaron-burden-yiI_e4zSEvo-unsplash_2.bb3402a2.jpg";